const alertShow = (type, message) => {
    const alert = document.getElementById('alert');
    let typeClass = '--Success';
    if (type == 'error') {
        typeClass = '--Error';
    }
    if (alert) {
        alert.innerHTML = '' +
            `<div class="Alert__container ${typeClass} --Is-hidden">` +
            `<div class="Alert__icon ${typeClass}"></div>` +
            `<p class="Alert__text">${message}</p>` +
            '<button class="Alert__close-button"></button>' +
            '</div>';
        alert.querySelector('.Alert__container').classList.remove('--Is-hidden');
        alert.querySelector('.Alert__close-button').addEventListener('click', () => {
            alert.querySelector('.Alert__container').classList.add('--Is-hidden');
            setTimeout(() => {
                    alert.querySelector('.Alert__container').remove();
                },
                1000
            );
        });
    }
}

export default alertShow;
